import { Injectable, Injector } from '@angular/core';



import { $frontendTypes } from './InventoryCounts.frontend.types'

@Injectable({ providedIn: 'root' })
export class InventoryCounts_FrontendFlowService {

  constructor(
    private injector: Injector
  ) {
  }

  public InventoryCounts: InventoryCounts_FrontendFlowService = this;

  // injecting lazily in order to avoid circular dependencies
}
